<div class="section-wrapper">
  <div class="section-wrapper-inner" #selectionInner>
    <button
      class="btn btn-plain section-item"
      *ngFor="let item of options"
      [class.active]="currentSection.name === item"
      (click)="setActiveSection(item)"
      [attr.data-section]="item"
    >
      {{ item }}
    </button>
  </div>
</div>

<div class="mb-transcript-section-scroller" *ngIf="options && options.length > 1">
  <button class="btn btn-plain" [disabled]="currentSection && currentSection.isFirst" (click)="scrollSectionBackward()">
    <span class="mb-icon mb-icon-back-thin"></span>
  </button>
  <button class="btn btn-plain" [disabled]="currentSection && currentSection.isLast" (click)="scrollSectionForward()">
    <span class="mb-icon mb-icon-forward-thin"></span>
  </button>
</div>
